import ApiService from './ApiService';

class DownloadCenterService {
  async download(apiUrlString, fileName, params = {}) {
    const hasPayload = Object.keys(params).length > 0;
    const method = hasPayload ? 'POST' : 'GET';
    const payload = hasPayload ? params : '<BLANK>';

    try {
      const response = await ApiService.call(apiUrlString, method, payload, {
        responseType: 'arraybuffer',
      });
      // const blob = await response.blob();
      console.log(response);
      const url = window.URL.createObjectURL(
        new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);

      link.click();

      link.parentNode.removeChild(link);
      return {
        success: true,
      };
    } catch (error) {
      console.log(error);

      return {
        success: false,
        code: error.code,
        message: error.message,
      };
    }
  }
}
export default new DownloadCenterService();
